module.exports = __webpack_public_path__ + "static/media/sky-terrace-6.6be1b373.jpg";